import { formatTargetSipLabel } from '../../../../display-values/sipPlanAmount'
import type { SipIdealPlanRecommendationApiResponse } from '../../api/idealRecommendation.types'
import { ALLOCATION_PLANS_THEME } from '../../../../lumpsum/plans-list/header/common/riskProfileHeaderTheme'

type IdealSipPlanRecommendationHeroProps = {
  planDetails: SipIdealPlanRecommendationApiResponse | null
}

export function IdealSipPlanRecommendationHero({ planDetails }: IdealSipPlanRecommendationHeroProps) {
  const idealSip = planDetails?.idealSip ?? 0
  const idealSipAmountLabel = `${formatTargetSipLabel({ rawAmount: idealSip })}/mo`

  return (
    <div className="px-5">
      <div className="flex flex-col gap-2">
        <div
          className="text-[14px] font-[500] leading-[130%]"
          style={{ color: ALLOCATION_PLANS_THEME.headerTextColor }}
        >
          Ideal Recommendation
        </div>
        <div className="text-[20px] leading-[130%] font-[400] text-[#6A6E6E] max-w-[90%]">
          {'Maintain '}
          <span className="font-[500] text-[#232323]">{idealSipAmountLabel} SIP</span>
          {' in this fund'}
        </div>
      </div>
    </div>
  )
}
